import * as types from '../const/action.types';

export function template(state = {}, action) {
    switch (action.type) {
        case types.TEMPLATE_SUCCESS:
            return action.data;
        case types.LOG_OUT:
            return {};
        default:
            return state;
    }
}

export function templates(state = [], action) {
    switch (action.type) {
        case types.LOAD_TEMPLATES_SUCCESS:
            return action.data;
        default:
            return state;
    }
}

export function templatesHasErrored(state = { hasErrored: false, error: '' }, action) {
    switch (action.type) {
        case types.TEMPLATE_HAS_ERROR:
            return {
                hasErrored: action.hasErrored,
                error: action.error,
            };

        default:
            return state;
    }
}

export function templatesIsLoading(state = false, action) {
    switch (action.type) {
        case types.TEMPLATES_IS_LOADING:
            return action.isLoading;
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/templates.reducer.js